module.exports = __webpack_public_path__ + "img/icon3@2x.bdb9d465.png";